module.exports = __webpack_public_path__ + "static/img/98.fa72e57.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ment/98.png
// module id = XBJr
// module chunks = 0